import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { getSettings } from '../lib/api';

const WhatsAppFloat = () => {
  const [num, setNum] = useState('923001234567');
  useEffect(() => {
    getSettings().then(s => { if (s.whatsapp_number) setNum(s.whatsapp_number); }).catch(() => {});
  }, []);
  const clean = num.replace(/[^0-9]/g, '');
  const msg = encodeURIComponent('Hello National Light! I would like to know more about your LED products.');
  return (
    <a href={`https://wa.me/${clean}?text=${msg}`} target="_blank" rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group">
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-green-600/30 hover:scale-110 transition-transform">
        <MessageCircle size={28} className="text-white" fill="white" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-[#0d5228] text-white text-sm font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden sm:block">Chat with us</span>
    </a>
  );
};

export default WhatsAppFloat;
